import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { User } from 'src/app/domain/user';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { BaseComponent } from '../base/base.component';
import { MatDialog } from '@angular/material/dialog';
import { UserConfigurationDialog } from 'src/app/tools/ui/user-configuration-box/user-configuration-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ESubContractingLab } from 'src/app/domain/enums/sub-contracting-lab';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { AddressService } from 'src/app/services/address.service';

@Component({
    selector: 'app-user-configuration',
    standalone: false,
    templateUrl: './user-configuration.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './user-configuration.component.scss'
})
export class UserConfigurationComponent extends BaseComponent implements OnInit, AfterViewInit {
    SamplerList: User[] = [];

    constructor(
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        protected override coreData: CoreData,
        private userService: UserService,
        public LoadingTask: LoadingTask) {
        super(coreData);

    }

    ngOnInit(): void {

    }

    ngAfterViewInit(): void {
        // let agency = this.route.snapshot.params['agency'] as string
        // let list = params.split(',')
        this.getSamplerList();

    }

    getLabLabel(lab: ESubContractingLab) {
        return StringConverter.getLabCodeName(lab)
    }

    getSamplerList() {
        if (!this.coreData.SamplerList || !this.coreData.Agency)
            this.router.navigate([ENavigationRoute.Home])

        this.userService.getSamplerByAgencyList(this.coreData.Agency!.AnalyticalUnitCode).subscribe(x => {

            this.SamplerList = _.intersectionBy(x, this.coreData.SamplerList, x => x.Puid)
        });
    }


    openUserConfigurationBox(user: User) {
        const dialogRef = this.dialog.open(UserConfigurationDialog,
            {
                width: '666px', 
                data: user
            });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.userService.updateUser(user).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Technicien modifié', this.snackBar);
                    }
                });
            }
        })
    }
}
